import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    backgroundColor: theme.palette.background.default,
  },
  appBar: {
    backgroundColor: theme.palette.primary.main,
    boxShadow: 'none',
    border: 0,
    top: 0,
    left: 0,
    right: 0,
  },
  toolbar: {
    minHeight: 56,
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },
  logo: {
    width: 120,
    height: 'auto',
    cursor: 'pointer',
  },
  userButton: {
    color: theme.palette.primary.contrastText,
    padding: theme.spacing(0.5),
  },
  logoutMenuItem: {
    minWidth: 120,
  },
  content: {
    flex: 1,
    paddingTop: 56,
  },
  inner: {
    width: '100%',
    padding: theme.spacing(4, 3),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(3, 2),
    },
  },
}))

export default useStyles
